import React from 'react';
import Skeleton from '@ynap/skeleton';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('LoginOrGuestSkeleton');

export const LoginOrGuestSkeleton = () => {
    const renderOption = (opened = false) => (
        <div className={bem('fieldGroup', opened ? 'opened' : null)}>
            <div className={bem('description')}>
                <Skeleton className={bem('item')} additionalStyle={{ width: '80px' }} />
                <Skeleton className={bem('item')} additionalStyle={{ width: '240px' }} />
            </div>
        </div>
    );

    return (
        <>
            <Skeleton className={bem('title')} />
            {renderOption(true)}
            {renderOption()}
        </>
    );
};
